<style>
.transition, .autocomplete, .showAll-transition, .autocomplete ul, .autocomplete ul li a{
  transition:all 0.3s ease-out;
  -moz-transition:all 0.3s ease-out;
  -webkit-transition:all 0.3s ease-out;
  -o-transition:all 0.3s ease-out;
}

.autocomplete ul{
  overflow-y: auto;
  height: 180px;
  font-family: sans-serif;
  position: absolute;
  list-style: none;
  background: #f8f8f8;
  padding: 1px 0;
  margin: 0;
  display: inline-block;
  min-width: 15%;
  margin-top: 0px;
  width: 100%;
  z-index: 9999;
  border: 1px solid #c2cfd6;
  border-radius: 0;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

}

.autocomplete ul:before{
  content: "";
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  border: 10px solid transparent;
  border-bottom: 10px solid #f8f8f8;
  left: 46%;
  top: -20px
}

.autocomplete ul li a{
  text-decoration: none;
  display: block;
  background: #f8f8f8;
  color: #2b2b2b;
  padding: 8px;
  padding-left: 10px;
}

.autocomplete ul li a:hover, .autocomplete ul li.focus-list a{
  color: white;
  background: #20a8d8;
}

.autocomplete ul li a span, /*backwards compat*/
.autocomplete ul li a .autocomplete-anchor-label{
  display: block;
  margin-top: 3px;
  color: grey;
  font-size: 13px;
}

.autocomplete ul li a:hover .autocomplete-anchor-label,
.autocomplete ul li.focus-list a span, /*backwards compat*/
.autocomplete ul li a:hover .autocomplete-anchor-label,
.autocomplete ul li.focus-list a span{ /*backwards compat*/
  color: white;
}

/*.showAll-transition{
  opacity: 1;
  height: 50px;
  overflow: hidden;
}
.showAll-enter{
  opacity: 0.3;
  height: 0;
}
.showAll-leave{
  display: none;
}*/
</style>
<template>
  <div :class="`${getClassName('wrapper')} autocomplete-wrapper`">
    <input
      ref="input"
      type="text"
      :id="id"
      :class="`${getClassName('input')} autocomplete-input`"
      :placeholder="placeholder"
      :name="name"
      @input="handleInput"
      @dblclick="handleDoubleClick"
      @blur="handleBlur"
      @keydown="handleKeyDown"
      @focus="handleFocus"
      autocomplete="off"
    />

    <div :class="`${getClassName('list')} autocomplete autocomplete-list`" v-show="showList && json.length">
      <ul>
        <li v-for="(data, i) in json" :class="activeClass(i)">
          <a href="#" @click.prevent="selectList(data)" @mousemove="mousemove(i)">
            <strong>{{data.descricaoVeiculo}}</strong><br>
            <small>{{data.clienteVeiculo}}</small>
            <div v-if="onShouldRenderChild" v-html="onShouldRenderChild(data)"></div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  let vm = {
    name: 'buscar-veiculo',
    props: {
      id: String,
      name: String,
      className: String,
      value: [String, Number],
      classes: {
        type: Object,
        default: () => ({
          wrapper: false,
          input: false,
          list: false,
          item: false
        })
      },
      placeholder: String,
      required: Boolean,
      // Intial Value
      // initValue: {
      //   type: String,
      //   default: ''
      // },
      // Manual List
      // options: Array,
      // Filter After Get the data
      filterByAnchor: {
        type: Boolean,
        default: true
      },
      // Anchor of list
      anchor: {
        type: String,
        required: false
      },
      // Label of list
      label: String,
      // Debounce time
      debounce: Number,
      // ajax URL will be fetched
      url: {
        type: String,
        required: false
      },
      // query param
      param: {
        type: String,
        default: 'q'
      },
      encodeParams: {
        type: Boolean,
        default: true
      },
      // Custom Params
      customParams: Object,
      // Custom Headers
      customHeaders: Object,
      // minimum length
      min: {
        type: Number,
        default: 0
      },
      // Create a custom template from data.
      onShouldRenderChild: Function,
      // Process the result before retrieveng the result array.
      process: Function,
      // Callback
      onInput: Function,
      onShow: Function,
      onBlur: Function,
      onHide: Function,
      onFocus: Function,
      onSelect: Function,
      onBeforeAjax: Function,
      onAjaxProgress: Function,
      onAjaxLoaded: Function,
      onShouldGetData: Function
    },
    data () {
      return {
        showList: false,
        type: '',
        json: [],
        focusList: '',
        debounceTask: undefined
      }
    },
    watch: {
      value (value) {
        this.setValue(value)
      },
      options (newVal, oldVal) {
        if (this.filterByAnchor) {
          const { type, anchor } = this
          const regex = new RegExp(`${type}`, 'i')
          const filtered = newVal.filter((item) => {
            const found = item[anchor].search(regex) !== -1
            return found
          })
          this.json = filtered
        } else {
          this.json = newVal
        }
      }
    },
    methods: {
      getClassName (part) {
        const { classes, className } = this
        if (classes[part]) return `${classes[part]}`
        return className ? `${className}-${part}` : ''
      },
      // Netralize Autocomplete
      clearInput () {
        this.showList = false
        this.type = ''
        this.json = []
        this.focusList = ''
      },
      // Get the original data
      cleanUp (data) {
        return JSON.parse(JSON.stringify(data))
      },
      handleInput (e) {
        const { value } = e.target
        this.showList = true
        // Callback Event
        if (this.onInput) this.onInput(value)
        // If Debounce
        if (this.debounce) {
          if (this.debounceTask !== undefined) clearTimeout(this.debounceTask)
          this.debounceTask = setTimeout(() => {
            return this.getData(value)
          }, this.debounce)
        } else {
          return this.getData(value)
        }
      },
      handleKeyDown (e) {
        let key = e.keyCode
        // Disable when list isn't showing up
        if (!this.showList) return
        // Key List
        const DOWN = 40
        const UP = 38
        const ENTER = 13
        const ESC = 27
        let altura = 0
        let posicao = 0
        const listLength = this.json.length - 1
        // Prevent Default for Prevent Cursor Move & Form Submit
        switch (key) {
          case DOWN:
            e.preventDefault()
            altura = listLength * 58
            posicao = $(this.$el).find('.autocomplete ul').scrollTop()
            if (posicao < altura && this.focusList < listLength) {
              this.focusList++
              $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50)
            }
            break
          case UP:
            e.preventDefault()
            posicao = $(this.$el).find('.autocomplete ul').scrollTop()
            if (this.focusList > 0) {
              this.focusList--
            }
            if (posicao > 0) {
              $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50)
            }
            break
          case ENTER:
            e.preventDefault()
            this.selectList(this.json[this.focusList])
            this.showList = false
            break
          case ESC:
            this.showList = false
            break
        }
        // const outOfRangeBottom = this.focusList > listLength
        // const outOfRangeTop = this.focusList < 0
        // const topItemIndex = 0
        // const bottomItemIndex = listLength
        // let nextFocusList = this.focusList
        // if (outOfRangeBottom) nextFocusList = topItemIndex
        // if (outOfRangeTop) nextFocusList = bottomItemIndex
        // this.focusList = nextFocusList
      },
      setValue (val) {
        $(this.$el).find('#veiculoDescricao').val(val)
      },
      handleDoubleClick () {
        this.json = []
        this.getData('')
        // Callback Event
        if (this.onShow) {
          this.onShow()
        }
        this.showList = true
      },
      handleBlur (e) {
        // Callback Event
        if (this.onBlur) {
          this.onBlur(e)
        }
        setTimeout(() => {
          // Callback Event
          if (this.onHide) {
            this.onHide()
          }
          this.showList = false
        }, 250)
      },
      handleFocus (e) {
        this.focusList = 0
        // Callback Event
        if (this.onFocus) {
          this.onFocus(e)
        }
      },
      mousemove (i) {
        this.focusList = i
      },
      activeClass (i) {
        const focusClass = i === this.focusList ? 'focus-list' : ''
        return `${focusClass}`
      },
      selectList (data) {
        this.$emit('input', data.descricao)
        // Deep clone of the original object
        const clean = this.cleanUp(data)
        // Put the selected data to type (model)
        this.type = clean[this.anchor]
        // Hide List
        this.showList = false
        // Callback Event
        if (this.onSelect) {
          this.onSelect(clean)
          $(this.$el).find('#veiculoDescricao').val(clean.descricao)
        }
      },
      deepValue (obj, path) {
        const arrayPath = path.split('.')
        for (var i = 0; i < arrayPath.length; i++) {
          obj = obj[arrayPath[i]]
        }
        return obj
      },
      composeParams (val) {
        const encode = (val) => this.encodeParams ? encodeURIComponent(val) : val
        let params = `${this.param}=${encode(val)}`
        if (this.customParams) {
          Object.keys(this.customParams).forEach((key) => {
            params += `&${key}=${encode(this.customParams[key])}`
          })
        }
        return params
      },
      composeHeader (ajax) {
        if (this.customHeaders) {
          Object.keys(this.customHeaders).forEach((key) => {
            ajax.setRequestHeader(key, this.customHeaders[key])
          })
        }
      },
      doAjax (val) {
        // Callback Event
        if (this.onBeforeAjax) {
          this.onBeforeAjax(val)
        }
        // Compose Params
        // let params = this.composeParams(val)

        // let ajax = new XMLHttpRequest()
        var self = this
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/veiculos/buscarVeiculosAtivos?busca=' + val
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.json = dados
          // if (data.lengthComputable && this.onAjaxProgress) this.onAjaxProgress(response)
          // Callback Event
          // this.onAjaxLoaded ? this.onAjaxLoaded(dados) : null
          // this.json = this.process ? this.process(dados) : dados
        })

        // Init Ajax
        // let ajax = new XMLHttpRequest()
        // ajax.open('GET', `${this.url}?${params}`, true)
        // this.composeHeader(ajax)
        // Callback Event
        // ajax.addEventListener('progress', (data) => {
        //   if(data.lengthComputable && this.onAjaxProgress) this.onAjaxProgress(data)
        // })
        // On Done
        // ajax.addEventListener('loadend', (e) => {
        //   const { responseText } = e.target
        //   let json = JSON.parse(responseText)
        //   // Callback Event
        //   this.onAjaxLoaded ? this.onAjaxLoaded(json) : null
        //   this.json = this.process ? this.process(json) : json
        // })
        // // Send Ajax
        // ajax.send()
      },
      getData (value) {
        if (value.length < 3) return
        // if (this.onShouldGetData) this.manualGetData(value)
        // else this.doAjax(value)
        this.doAjax(value)
      },
      // Do Ajax Manually, so user can do whatever he want
      manualGetData (val) {
        const task = this.onShouldGetData(val)
        if (task && task.then) {
          return task.then((options) => {
            this.json = options
          })
        }
      }
    },
    created () {
      // Sync parent model with initValue Props
      this.type = this.initValue ? this.initValue : null
      $(this.$el).val(this.value)
    },
    mounted () {
      $(this.$el).val(this.value)
      if (this.required) this.$refs.input.setAttribute('required', this.required)
    }
  }
  module.exports = vm
</script>



// WEBPACK FOOTER //
// src/components/spark-components/spark-scrollbar/SparkBuscarVeiculo.vue